import React from 'react';
import { Link } from 'react-router-dom';

function FooterChinese() {
  return (
    <footer style={{ 
      background: '#004080', 
      color: 'white', 
      padding: '48px 24px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      position: 'relative'
    }}>
      <div className="footer-content" style={{ 
        maxWidth: '1200px', 
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: '16px'
      }}>
        {/* Logo and Tagline */}
        <div style={{ flex: '1 1 300px' }}>
          <h2 style={{ fontSize: '24px', marginBottom: '12px' }}>Connection Health Care</h2>
          <img 
            src="ConnectionHealthLogoTransparent.png" 
            alt="Connection Health Care Logo" 
            style={{ 
              height: '250px', 
              width: 'auto',
            }} 
          />
        </div>

        {/* Quick Links */}
        <div style={{ flex: '1 1 200px' }}>
          <h3 style={{ fontSize: '18px', marginBottom: '16px' }}>探索</h3>
          <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
            <li style={{ marginBottom: '8px' }}><Link to="/" style={{ color: 'white', textDecoration: 'none' }} onClick={() => window.scrollTo(0, 0)}>首頁</Link></li>
            <li style={{ marginBottom: '8px' }}><Link to="/zhservices" style={{ color: 'white', textDecoration: 'none' }} onClick={() => window.scrollTo(0, 0)}>服務</Link></li>
            <li style={{ marginBottom: '8px' }}><Link to="/zhbookingform" style={{ color: 'white', textDecoration: 'none' }} onClick={() => window.scrollTo(0, 0)}>立即預約</Link></li>
            <li style={{ marginBottom: '8px' }}><Link to="/zhaboutus" style={{ color: 'white', textDecoration: 'none' }} onClick={() => window.scrollTo(0, 0)}>關於我們</Link></li>
            <li style={{ marginBottom: '8px' }}><Link to="/zhourteam" style={{ color: 'white', textDecoration: 'none' }} onClick={() => window.scrollTo(0, 0)}>我們的團隊</Link></li>
            <li style={{ marginBottom: '8px' }}><Link to="/zhcareer" style={{ color: 'white', textDecoration: 'none' }} onClick={() => window.scrollTo(0, 0)}>職業機會</Link></li>
            <li style={{ marginBottom: '8px' }}><a href="#contact-form" style={{ color: 'white', textDecoration: 'none' }}>聯絡我們</a></li>
          </ul>
        </div>

        {/* Contact Info */}
        <div style={{ flex: '1 1 300px' }}>
          <h3 style={{ fontSize: '18px', marginBottom: '16px' }}>聯絡我們</h3>
          <p style={{ marginBottom: '8px' }}>電子郵件: info@connectionhealthcare.ca</p>
          <p style={{ marginBottom: '8px' }}>電話: 905-597-1892 </p>
          <p style={{ marginBottom: '8px' }}>傳真: 905-948-1891 </p>
          <p style={{ marginBottom: '8px' }}>24小時提供服務</p>
          <a href="https://maps.app.goo.gl/ZLopD6iwB52QdmmX7" target="_blank" rel="noopener noreferrer" style={{ color: 'white', textDecoration: 'none' }}>
            <p style={{ marginBottom: '8px' }}>1 West Pearce St. Suite 201, Richmond Hill, ON L4B 3K3</p>
          </a>
        </div>
      </div>

      {/* Policy Links */}
      <div style={{ 
        display: 'flex',
        justifyContent: 'center',
        gap: '24px',
        width: '100%',
        borderTop: '1px solid rgba(255,255,255,0.1)',
        marginTop: '24px',
        paddingTop: '16px'
      }}>
        <Link to="/privacy-policy" style={{ color: 'white', textDecoration: 'none' }} onClick={() => window.scrollTo(0, 0)}>隱私政策</Link>
        <Link to="/accessibility" style={{ color: 'white', textDecoration: 'none' }} onClick={() => window.scrollTo(0, 0)}>無障礙政策</Link>
        {/* <Link to="/bill-of-rights" style={{ color: 'white', textDecoration: 'none' }} onClick={() => window.scrollTo(0, 0)}>Bill of Rights</Link> */}
      </div>

      {/* Copyright */}
      <div style={{ 
        marginTop: '16px',
        width: '100%',
        textAlign: 'center'
      }}>
        <p>&copy; 2025 Connection Health Care - 版權所有，並保留一切權利.</p>
      </div>
    </footer>
  );
}

export default FooterChinese;
